const groupLinks = {
  '现场频道': ['今日瓜条', '现场直击', '实锤时间线', '澄清辟谣'],
  '关于我们': ['平台说明', '信源原则', '内容边界', '联系我们'],
  '帮助支持': ['常见问题', '投稿线索', '侵权反馈', '前排提醒'],
};

export default function Footer() {
  return (
    <footer className="border-t border-primary-200 bg-primary-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-12">
        <div className="grid gap-8 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          {/* brand */}
          <div>
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-display text-xl font-bold tracking-tight text-background-50">cg51</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-primary-100/90">
              一处轻量吃瓜现场聚合入口，把热点串成瓜线，把时间线理清楚，把前排位给你留好。看图、看线、看澄清，吃瓜别上头。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {['ri-weibo-line', 'ri-wechat-line', 'ri-tiktok-fill', 'ri-youtube-line'].map((ic) => (
                <a key={ic} href="#top" aria-label="关注我们" className="flex h-9 w-9 items-center justify-center rounded-md border border-primary-700 text-primary-100 hover:border-accent-500 hover:bg-accent-500 hover:text-primary-950 transition-colors">
                  <i className={`${ic} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* link groups */}
          {Object.entries(groupLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-50">{title}</h4>
              <ul className="mt-4 space-y-2.5">
                {links.map((l) => (
                  <li key={l}>
                    <a href="#top" className="text-sm text-primary-100/80 hover:text-accent-300 transition-colors whitespace-nowrap">{l}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-primary-100/70">
            © {new Date().getFullYear()} cg51 · 内容仅供信息梳理，请以当事人及官方信源为准
          </p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-primary-100/70">
            <a href="#top" className="hover:text-accent-300 transition-colors">隐私说明</a>
            <a href="#top" className="hover:text-accent-300 transition-colors">侵权反馈</a>
            <a href="#faq" className="hover:text-accent-300 transition-colors">存疑澄清</a>
          </div>
        </div>
      </div>
    </footer>
  );
}